module.exports = "/images/vendor/desiigner-svg/svg/ui/arrow-top-right.svg?865ffac68deb25220c72a1e44777aaf0";